import { withHandlers, compose, branch, withPropsOnChange } from 'recompose';
import withLocalStorage from 'utilities/withLocalStorage';
import getConfig from 'next/config';
import { Mixpanel } from 'utilities/mixpanel';
import logger from 'utilities/logger';
const { publicRuntimeConfig } = getConfig();

// Setters
const onCreatedWebId = ({ setLocalStoredValue }) => value => {
  const web_id = value ? value : '';
  setLocalStoredValue('cove-web-id', web_id);
};

const onCreatedCustomerId = ({ setLocalStoredValue }) => value => {
  const customer_id = value ? value : '';
  setLocalStoredValue('cove-customer-id', customer_id);
};

const onCreatedAccessToken = ({ setLocalStoredValue }) => value => {
  logger.log('SavedState', 'Created access token');
  const accessToken = value ? value : '';
  setLocalStoredValue('cove-access-token', accessToken);
};

const onCreateRisk = ({ setLocalStoredValue }) => value => {
  const risk = value ? value : {};
  setLocalStoredValue('cove-risk', JSON.stringify(risk));
};

const onCreateReferral = ({ setLocalStoredValue }) => value => {
  const risk = value ? value : undefined;
  setLocalStoredValue('cove-referral-code', risk);
  Mixpanel.track('Added Partner Referral Code', {
    Value: risk
  });
};

const onCreatedCoverage = ({ setLocalStoredValue, removeLocalStoredValue }) => ({
  coverage_id
}) => {
  setLocalStoredValue('cove-coverage-id', coverage_id);
};

const onCreatedQuote = ({ setLocalStoredValue }) => quote_id => {
  setLocalStoredValue('cove-quote-id', quote_id);
};

const onCreateAnswers = ({ setLocalStoredValue }) => value => {
  const answers = value ? value : {};
  setLocalStoredValue('answers', JSON.stringify(answers));
};

const onReceivedCognitoCredentials = ({ setLocalStoredValue }) => (email, cognitoCredentials) => {
  if (email && cognitoCredentials) {
    const lastAuthUser = email;
    const prefix = `CognitoIdentityServiceProvider.${publicRuntimeConfig.USER_POOL_WEB_CLIENT_ID}`;
    setLocalStoredValue(`${prefix}.LastAuthUser`, lastAuthUser);
    setLocalStoredValue(`${prefix}.${lastAuthUser}.accessToken`, cognitoCredentials.AccessToken);
    setLocalStoredValue(`${prefix}.${lastAuthUser}.idToken`, cognitoCredentials.IdToken);
    setLocalStoredValue(`${prefix}.${lastAuthUser}.refreshToken`, cognitoCredentials.RefreshToken);
    setLocalStoredValue(`${prefix}.${lastAuthUser}.clockDrift`, 0);
    setLocalStoredValue('cove-access-token', cognitoCredentials.AccessToken);
  } else console.error('Cognito Credentials not found');
};

const onAdjustedCoverage = ({ setLocalStoredValue }) => value => {
  const adjustedCoverage = value ? value : {};
  setLocalStoredValue('adjusted-coverage', JSON.stringify(adjustedCoverage));
};

const onAdjustedQuote = ({ setLocalStoredValue }) => value => {
  const adjustedQuote = value ? value : {};
  setLocalStoredValue('adjusted-quote', JSON.stringify(adjustedQuote));
};

// List setters
const withStateSetters = withHandlers({
  onCreatedAccessToken,
  onCreatedCoverage,
  onCreatedCustomerId,
  onCreatedQuote,
  onCreatedWebId,
  onCreateReferral,
  onReceivedCognitoCredentials,
  onCreateRisk,
  onCreateAnswers,
  onAdjustedCoverage,
  onAdjustedQuote
});

const withStoredState = withPropsOnChange(['localStorage'], ({ localStorage }) => {
  return {
    // Current value
    web_id: localStorage.getItem('cove-web-id'),
    accessToken: localStorage.getItem('cove-access-token'),
    customer_id: localStorage.getItem('cove-customer-id'),
    savedRisk: JSON.parse(localStorage.getItem('cove-risk') || '{}'),
    coverage_id: localStorage.getItem('cove-coverage-id'),
    quote_id: localStorage.getItem('cove-quote-id'),
    answers: JSON.parse(localStorage.getItem('answers') || '{}'),
    amendedCoverage: JSON.parse(localStorage.getItem('amended-coverage') || '{}'),
    adjustedCoverage: JSON.parse(localStorage.getItem('adjusted-coverage') || '{}'),
    amendedQuote: JSON.parse(localStorage.getItem('amended-quote') || '{}'),
    adjustedQuote: JSON.parse(localStorage.getItem('adjusted-quote') || '{}'),
    referral_code: localStorage.getItem('cove-referral-code')
  };
});

export default compose(
  branch(props => !props.localStorage, withLocalStorage),
  // withLocalStorage,
  withStateSetters,
  withStoredState
);
